import { HTMLAttributes, ReactNode } from 'react'


import { Label, LabelContainer } from './styles'

interface IProps extends HTMLAttributes<HTMLSpanElement> {
  isRequired?: boolean
  isInvalid?: boolean
  children: ReactNode
}

export function FieldLabel({
  children,
  isRequired = false,
  isInvalid,
  ...rest
}: IProps) {
  return (
    <LabelContainer>
      <Label isInvalid={isInvalid} {...rest}>
        {children}
      </Label>
      {isRequired && (
        <Label isRequired={isRequired} {...rest}>
          *
        </Label>
      )}
    </LabelContainer>
  )
}
